import OBTButton, { ButtonTheme, ButtonType } from './OBTButton';

export default OBTButton;
export { ButtonTheme, ButtonType };